import styled from 'styled-components';

import {
  green,
  black,
  lighterYellow,
  lightGreen,
  boxShadow1,
  border1,
} from 'utils/style/colors';

interface ITabItem {
  active: boolean;
}

interface IMessageProps {
  unread: boolean;
  selected: boolean;
}

export const Section = styled.section`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
`;

interface IContainerProps {
  halve: boolean;
}

export const Container = styled('div')<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.halve ? '40%' : '100%')};
  margin-left: ${(props) => props.halve && '1rem'};
  @media only screen and (max-width: 800px) {
    display: ${(props) => (props.halve ? 'none' : 'flex')};
    border-radius: 0px;
    box-shadow: 0;
  }
`;

export const Box = styled.div`
  padding: 12px;
  background: var(--exact-white);
  border-radius: 10px;
  box-shadow: ${boxShadow1};
  /* border-bottom: 1px solid #eee; */
`;

export const TabsList = styled.div`
  display: flex;
  line-height: 2rem;
`;

export const TabItem = styled('span')<ITabItem>`
  cursor: pointer;
  font-weight: 500;
  padding-bottom: 0.5em;
  margin: 0 0.5em;
  color: ${(props) => (props.active ? green : '#b7bfc6')};
  box-shadow: ${(props) => (props.active ? `inset 0 -3px ${green}` : '')};
  transition: all 0.2s;
  &:hover {
    box-shadow: ${(props) => (!props.active ? 'inset 0 -3px #b7bfc6' : '')};
    color: ${(props) => (!props.active ? black : '')};
  }
  width: 90px;
  text-align: center;
`;

export const ArchiveBox = styled.div`
  align-items: center;
  justify-content: center;
  width: 60px !important;
  min-width: 60px !important;
  display: flex;
`;

export const ArchiveButton = styled.span`
  cursor: pointer;
`;

export const Message = styled('div')<IMessageProps>`
  display: flex;
  border-top: ${border1};
  border-bottom: ${border1};
  justify-content: space-between;
  background-color: ${(props) =>
    props.selected ? lighterYellow : props.unread && '#eaffe7'};

  &:hover {
    background-color: ${lightGreen};
  }

  & {
    ${ArchiveBox} > * {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    ${ArchiveBox} > * {
      display: initial;
    }
  }
  &:hover {
    ${ArchiveBox} > * {
      display: initial;
    }
  }
`;

export const Content = styled.div`
  padding: 1em 1em 1em 0em;
`;

export const Date = styled.span`
  color: #777;
  font-size: 0.8em;
  margin-left: 1em;
`;
